// bulkUploadActions.js
export const INIT_BULK_UPLOAD_REQUEST = 'INIT_BULK_UPLOAD_REQUEST';
export const SET_BULK_UPLOAD = 'SET_BULK_UPLOAD'; // use to set bulk upload data
export const ERROR_BULK_UPLOAD = 'ERROR_BULK_UPLOAD'; // use to handle all types of errors related to bulk upload
export const BULK_UPLOAD_PROGRESS = 'BULK_UPLOAD_PROGRESS'; // use to track upload progress

export function initBulkUploadRequest() {
  return { type: INIT_BULK_UPLOAD_REQUEST };
}

export function setBulkUpload(data) {
  return { type: SET_BULK_UPLOAD, payload: data };
}

export function errorBulkUpload(error) {
  return { type: ERROR_BULK_UPLOAD, payload: error };
}

export function bulkUploadProgress(progress) {
  return { type: BULK_UPLOAD_PROGRESS, payload: progress };
}
